import React from "react";
import { Route, Redirect } from "react-router-dom";
import { useAppSelector } from "types/hooks";

const PrivateRoute = ({ component: Component, ...rest }) => {
  const auth = useAppSelector((state) => state.auth);
  const isAuthenticated = !!(auth?.user?.key || auth?.deviceToken);

  return (
    <Route
      {...rest}
      render={(props) => (isAuthenticated ? <Component {...props} /> : <Redirect to="/HomePage" />)}
    />
  );
};

export default PrivateRoute;
